<template>
    <!--  BEGIN SIDEBAR  -->
    <div class="sidebar-wrapper sidebar-theme">
        <nav ref="menu" id="sidebar">
            <div class="shadow-bottom"></div>

            <perfect-scrollbar class="list-unstyled menu-categories" tag="ul" :options="{ wheelSpeed: 0.5, swipeEasing: !0, minScrollbarLength: 40, maxScrollbarLength: 300, suppressScrollX: true }">
                <template v-for="item in $store.getters['user'].opcionesMenu">
                    <li class="menu" :key="item.descripcion" v-if="item.children.length > 0">
                        <a :href="'#'+item.descripcion.replace(/\s+/g, '')" v-b-toggle class="dropdown-toggle" @click.prevent >
                            <div class="">
                                <b-icon :icon="item.icon" variant="dark"></b-icon>

                                <span>{{ $t(item.descripcion) }}</span>
                            </div>
                            <div>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="feather feather-chevron-right"
                                >
                                    <polyline points="9 18 15 12 9 6"></polyline>
                                </svg>
                            </div>
                        </a>
                        <b-collapse :id="item.descripcion.replace(/\s+/g, '')" accordion="menu">
                            <ul class="collapse submenu list-unstyled show" v-for="(child, i) in item.children" :key="i">
                                <router-link tag="li" :to="child.ruta" @click.native="toggleMobileMenu">
                                    <a>{{ $t(child.descripcion) }}</a>
                                </router-link>
                            </ul>
                        </b-collapse>
                    </li>
                    <li class="menu" :key="item.descripcion" v-else-if="item.parent_id == null">
                        <a :href="'#'+item.id" v-b-toggle class="dropdown-toggle" @click.prevent >
                            <div class="">
                                <router-link tag="li" :to="item.ruta" @click.native="toggleMobileMenu">
                                    <b-icon :icon="item.icon" variant="dark"></b-icon>
                                    <span>{{ $t(item.descripcion) }}</span>
                                </router-link>
                                
                            </div>
                        </a>
                    </li>
                </template>
                

                <!--</ul>-->
            </perfect-scrollbar>
        </nav>
    </div>
    <!--  END SIDEBAR  -->
</template>
<script>
    export default {
        data() {
            return { menu_collapse: 'dashboard' };
        },

        watch: {
            $route(to) {
                const selector = document.querySelector('#sidebar a[href="' + to.path + '"]');
                const ul = selector.closest('ul.collapse');
                if (!ul) {
                    const ele = document.querySelector('.dropdown-toggle.not-collapsed');
                    if (ele) {
                        ele.click();
                    }
                }
            }
        },

        mounted() {
            // default menu selection on refresh
            const selector = document.querySelector('#sidebar a[href="' + window.location.pathname + '"]');
            if (selector) {
                const ul = selector.closest('ul.collapse');
                if (ul) {
                    let ele = ul.closest('li.menu').querySelectorAll('.dropdown-toggle');
                    if (ele) {
                        ele = ele[0];
                        setTimeout(() => {
                            ele.click();
                        });
                    }
                } else {
                    selector.click();
                }
            }
        },

        methods: {
            toggleMobileMenu() {
                if (window.innerWidth < 991) {
                    this.$store.commit('toggleSideBar', !this.$store.state.is_show_sidebar);
                }
            }
        }
    };
</script>
